import * as React from 'react';
import { Show, SimpleShowLayout, TextField } from 'react-admin';

export const ProductShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="scenario" />
      <TextField source="type" />
      <TextField source="price" />
      <TextField source="priceUnit" />
      <TextField source="num" />
      <TextField source="purchaseType" />
      <TextField source="description" />
      <TextField source="createdAt" />
      <TextField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
